<template>
    <div class="l-row">
        <div class="l-row__column">
            <div class="l-row l-row--touch m-title" >
                <div class="l-row__column l-row__column--paddingless m-title__title">
                    <h1 class="a-title">{{ title }}</h1>
                    <p
                        v-if="subtitle"
                        class="m-title__subtitle"
                    >{{ subtitle }}</p>
                </div>
                <div
                    v-if="this.$slots.default"
                    class="l-row__column l-row__column--paddingless m-title__slot"
                >
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        }
    }
}
</script>
